// extracted by mini-css-extract-plugin
module.exports = {"container":"group_container__684p2"};